import React, { useState, useEffect } from "react";
import { Form, Typography, Input, Space, Button, Radio, Switch } from "antd";

import { SaveOutlined, UndoOutlined } from "@ant-design/icons";

//Importaciones para el uso de Redux
import { useDispatch } from "react-redux";
import { updateRolEnviromentAction } from "../../../../../actions/rolEnviromentActions";

// Picker Color
import ColorPicker from "rc-color-picker";

//Styles
import curStyle from "../../../../../css/GlobalCmp.module.css";

//Importaciones Propias
import CST from "../../../../../utils/CustomSettings";
import { showNotification } from "../../../../../utils/ShowNotification";
import CRM from "../../../../../utils/CrmService";

export default function VntMediosPublForm(props) {
  const { record, closeModal, currentUser, varEffec } = props;
  const [form] = Form.useForm();
  const [curId, setCurId] = useState(record.mdo_id);
  const [loadingButton, setLoadingButton] = useState(false);
  const [colorFondo, setColorFondo] = useState(record.mdo_color);
  const [general, setGeneral] = useState(record.mdo_id > 0 ? record.mdo_comun : 0);
  const [web, setWeb] = useState(record.mdo_id > 0 ? record.mdo_web : 0);
  const [presupuesto, setPresupuesto] = useState(record.mdo_id > 0 ? record.mdo_presupuesto : 0);
  const [activo, setActivo] = useState(record.mdo_id > 0 ? record.mdo_activo : 0);

  useEffect(() => {
    setCurId(record.mdo_id);
  }, [varEffec]);

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const layout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 20 },
  };

  const { Title } = Typography;

  const guardarCambios = async (values) => {
    console.log(values);
    setLoadingButton(true);
    let val_record = await CRM.sendVntMediosPubl(
      currentUser,
      curId,
      colorFondo,
      general,
      web,
      presupuesto,
      activo,
      "VntMediosPubl",
      values
    );
    console.log(val_record);
    if (Number.parseInt(val_record.type) > 0) {
      updateEnviroment(val_record.datos.rol_entorno);
      showNotification(
        "topRight",
        4,
        "GESTION DE MEDIOS PUBLICIDAD",
        "REGISTRO EXITOSO"
      );
    } else {
      showNotification(
        "topRight",
        2,
        "GESTION DE MEDIOS PUBLICIDAD",
        val_record.message
      );
    }
    setLoadingButton(false);
    closeModal();
  };

  //Renderizacion del componente
  return (
    <Form
      {...layout}
      form={form}
      name="VntMediosPubl"
      onFinish={guardarCambios}
      initialValues={{
        mdo_nombre: record.mdo_id > 0 ? record.mdo_nombre : "",
      }}
      scrollToFirstError
    >
      <Form.Item>
        <Title
          level={4}
          style={{
            padding: 2,
            margin: 2,
            fontWeight: 600,
            textAlign: "left",
            color: CST.colorSec,
          }}
        >
          {record.mdo_id > 0
            ? "ACTUALIZAR MEDIOS PUBLICIDAD"
            : "AGREGAR MEDIOS PUBLICIDAD"}
        </Title>
      </Form.Item>
      <Form.Item
        name="mdo_nombre"
        label="Nombre"
        rules={[
          {
            required: true,
            message: "El nombre es obligatorio",
          },
        ]}
      >
        <Input
          style={{ textTransform: "uppercase" }}
          value={record.mdo_id > 0 ? record.mdo_nombre : ""}
        />
      </Form.Item>
      <Form.Item
        name="mdo_color"
        label="Color"
        wrapperCol={{ span: 10 }}
        style={{ display: "flex", flexDirection: "row" }}
      >
        <Space direction="horizontal">
          <Input value={colorFondo} style={{ width: 100 }} />
          <ColorPicker
            animation="slide-up"
            color={record.mdo_id > 0 ? record.mdo_color : ""}
            onChange={(color) => setColorFondo(color.color)}
          />
        </Space>
      </Form.Item>
      <Form.Item
        name="mdo_general"
        label="General"
        wrapperCol={{ span: 10 }}
        style={{ display: "flex", flexDirection: "row" }}
      >
        <Space direction="horizontal" size={10}>
        <Switch
            checked={general}
            onChange={(val) => setGeneral(val ? 1 : 0)}
            checkedChildren="SI"
            unCheckedChildren="NO"
            defaultChecked
          />

          Llega por la Web:
          <Switch
            checked={web}
            onChange={(val) => setWeb(val ? 1 : 0)}
            checkedChildren="SI"
            unCheckedChildren="NO"
            defaultChecked
          />
        </Space>
      </Form.Item>
      <Form.Item
        name="mdo_presupuesto"
        label="Tiene presupuesto"
        wrapperCol={{ span: 10 }}
        style={{ display: "flex", flexDirection: "row" }}
      >
        <Space direction="horizontal" size={43}>
        <Switch
            checked={presupuesto}
            onChange={(val) => setPresupuesto(val ? 1 : 0)}
            checkedChildren="SI"
            unCheckedChildren="NO"
            defaultChecked
          />
          
          Activo:
          <Switch
            checked={activo}
            onChange={(val) => setActivo(val ? 1 : 0)}
            checkedChildren="SI"
            unCheckedChildren="NO"
            defaultChecked
          />
          
        </Space>
      </Form.Item>
      <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
        <Space>
          <Button
            type="primary"
            htmlType="submit"
            className={curStyle.btnOrange}
            loading={loadingButton}
          >
            <SaveOutlined /> Guardar
          </Button>
          <Button
            type="primary"
            className={curStyle.btnInverse}
            onClick={() => closeModal()}
          >
            <UndoOutlined /> Cancelar
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
